/** Tiny CSS-drawn triangle that inherits `currentColor`.
 *  Used in place of Unicode glyphs like ▸ ▶ ◀ which can fall back to a
 *  different font and drift off the pixel-font baseline. */

export function Triangle({ direction = 'right' }: { direction?: 'left' | 'right' }) {
  const style: React.CSSProperties = {
    display: 'block',
    width: 0,
    height: 0,
    borderTop: '4px solid transparent',
    borderBottom: '4px solid transparent',
    flexShrink: 0,
  };
  if (direction === 'right') style.borderLeft = '6px solid currentColor';
  else style.borderRight = '6px solid currentColor';
  return <span aria-hidden="true" style={style} />;
}
